import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { DssTemaEnum } from 'enums/dss-tema.enum';
import { applyDssBodyClass } from '../layout/dss/dss';

/**
 * Aplica a classe de body DSS (`dss-style-dark`/`dss-style-light`) de forma reativa,
 * reagindo à montagem, à troca de rota e à troca de tema.
 */
export function useDssTheme(theme: DssTemaEnum): void {
  const { pathname } = useLocation();

  useEffect(() => {
    applyDssBodyClass(true, theme);
  }, [theme, pathname]);
}
